"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CategoryIcon = function CategoryIcon() {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: "10px",
      height: "10px",
      viewBox: "0 0 10 10",
      version: "1.1"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      id: "Iteration",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      id: "xAxis-Selector",
      transform: "translate(-183.000000, -311.000000)",
      fill: "#2C75B0"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      id: "Rectangle-409-+-364-+-MWh-Copy",
      transform: "translate(163.000000, 289.000000)"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      id: "Group-20",
      transform: "translate(19.000000, 10.000000)"
    },
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M4.5,12 L11,18.5 L7.5,22 L1,15.5 L1,12 L4.5,12 Z M3.5,13.5 C2.94771525,13.5 2.5,13.9477153 2.5,14.5 C2.5,15.0522847 2.94771525,15.5 3.5,15.5 C4.05228475,15.5 4.5,15.0522847 4.5,14.5 C4.5,13.9477153 4.05228475,13.5 3.5,13.5 Z",
      id: "item-category"
    }))))))
  );
};

var _default = CategoryIcon;
exports["default"] = _default;